import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { CivicFacilityList } from 'types/api'
import { BaseResponse } from 'types/utils'

export const civicFacilitiesQueryKey = ['civic-facilities'] as const

interface useCivicFacilitiesProps {
  search: string
}

export function useCivicFacilities({ search }: useCivicFacilitiesProps) {
  const queryKey = ['civic-facilities', search]

  async function getCivicFacilities() {
    const params = new URLSearchParams()
    params.set('limit', '-1')
    if (search?.trim()) {
      params.set('search', search.trim())
    }

    const response = await apiClient.get<BaseResponse<CivicFacilityList>>(
      SNA_PREFIX + `civic-facilities?${params.toString()}`
    )
    return response.data.results
  }

  return useQuery({
    queryKey,
    queryFn: getCivicFacilities
  })
}
